<template>
  <div>
    <el-card shadow="never" style="margin-bottom: 12px;">
      <span>云仓售卖</span>
      <el-switch v-model="warehouseJoin" active-color="#13ce66" style="margin-left: 12px;" @change="saveWarehouse"></el-switch>
      <span style="margin-left: 8px; color: #909399;">关闭时，云仓订单不展示包装商品</span>
      <div style="margin-top: 8px; color: #909399; font-size: 12px;">
        关联范围为「指定主品」的行可用「导入主品」：按<strong>商品ID（goods_id）</strong>批量导入，
        <strong>导入后立即保存</strong>（追加，已关联自动跳过）；失败行可在导入弹窗下载失败明细。
      </div>
    </el-card>
    <el-form :inline="true" size="small">
      <el-form-item label="商品名称">
        <el-input v-model="query.item_name" clearable></el-input>
      </el-form-item>
      <el-form-item label="货号">
        <el-input v-model="query.item_bn" clearable></el-input>
      </el-form-item>
      <el-form-item label="启用">
        <el-select v-model="query.is_enable" clearable placeholder="全部">
          <el-option label="启用" value="1"></el-option>
          <el-option label="停用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联范围">
        <el-select v-model="query.rel_item_type" clearable placeholder="全部">
          <el-option label="全部主品" value="all"></el-option>
          <el-option label="指定主品" value="some"></el-option>
          <el-option label="未关联" value="none"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="load(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" v-loading="loading">
      <el-table-column prop="item_name" label="商品名称"></el-table-column>
      <el-table-column prop="item_bn" label="货号"></el-table-column>
      <el-table-column label="启用" width="90">
        <template slot-scope="scope">
          <el-switch :value="scope.row.is_enable == 1" @change="changeEnable(scope.row, $event)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="排序" width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.sort" size="mini" @change="changeSort(scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="关联范围" width="120">
        <template slot-scope="scope">
          <span>{{ relText(scope.row.rel_item_type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="170">
        <template slot-scope="scope">
          <el-button type="text" @click="openRel(scope.row)">关联主品</el-button>
          <!-- 导入只对「指定主品」有意义（导入会把范围置为 some），全部主品/未关联不展示入口 -->
          <ImportDistributor
            v-if="scope.row.rel_item_type === 'some'"
            button-name="导入主品"
            button-type="text"
            file-name="关联主品导入模板"
            file-type="wrapping_main_goods"
            :rel-id="scope.row.wrapping_goods_id"
            :title="'导入关联主品：' + (scope.row.item_name || '')"
            @handleClose="afterImport"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 12px;"
      background
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      @current-change="load"
    ></el-pagination>

    <el-dialog title="关联主品" :visible.sync="relVisible" width="720px">
      <el-radio-group v-model="relForm.rel_item_type">
        <el-radio label="all">全部主品</el-radio>
        <el-radio label="some">指定主品</el-radio>
        <el-radio label="none">不关联</el-radio>
      </el-radio-group>
      <div v-if="relForm.rel_item_type === 'some'" style="margin-top: 12px;">
        <el-table :data="selectedMainGoods" size="mini" max-height="320" v-loading="selectedLoading">
          <el-table-column prop="goods_id" label="商品ID" width="90"></el-table-column>
          <el-table-column label="名称" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.item_name || scope.row.itemName }}
            </template>
          </el-table-column>
          <el-table-column prop="item_bn" label="货号" width="140"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button type="text" @click="removeMainGoods(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" size="small" style="margin-top: 12px;" @click="openGoodsPicker">选择商品</el-button>
      </div>
      <span slot="footer">
        <el-button @click="relVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRel">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import fetch from '@/utils/fetch'
import ImportDistributor from '@/components/importDistributor'

export default {
  components: { ImportDistributor },
  data () {
    return {
      warehouseJoin: false,
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      query: {
        item_name: '',
        item_bn: '',
        is_enable: '',
        rel_item_type: ''
      },
      relVisible: false,
      relForm: {
        wrapping_goods_id: 0,
        rel_item_type: 'none',
        main_goods_ids: []
      },
      selectedMainGoods: [],
      selectedLoading: false
    }
  },
  mounted () {
    this.loadWarehouse()
    this.load(1)
  },
  methods: {
    relText (type) {
      return { all: '全部主品', some: '指定主品', none: '未关联' }[type] || type
    },
    loadWarehouse () {
      fetch({ url: '/goods/wrapping/warehouse', method: 'get' }).then(res => {
        const data = res.data.data || {}
        this.warehouseJoin = data.wrapping_warehouse_join == 1
      })
    },
    saveWarehouse (value) {
      fetch({
        url: '/goods/wrapping/warehouse',
        method: 'put',
        data: { wrapping_warehouse_join: value ? 1 : 0 }
      })
    },
    load (page) {
      this.page = page
      this.loading = true
      return fetch({
        url: '/goods/wrapping',
        method: 'get',
        params: Object.assign({ page: this.page, pageSize: this.pageSize }, this.query)
      }).then(res => {
        const data = res.data.data || {}
        this.list = data.list || []
        this.total = data.total_count || 0
      }).finally(() => {
        this.loading = false
      })
    },
    changeEnable (row, value) {
      fetch({
        url: '/goods/wrapping/enable',
        method: 'put',
        data: { wrapping_goods_id: row.wrapping_goods_id, is_enable: value ? 1 : 0 }
      }).then(() => {
        row.is_enable = value ? 1 : 0
      })
    },
    changeSort (row) {
      fetch({
        url: '/goods/wrapping/sort',
        method: 'put',
        data: { wrapping_goods_id: row.wrapping_goods_id, sort: row.sort }
      })
    },
    openRel (row) {
      const mainGoodsIds = (row.main_goods_ids || []).slice()
      this.relForm = {
        wrapping_goods_id: row.wrapping_goods_id,
        rel_item_type: row.rel_item_type || 'none',
        main_goods_ids: mainGoodsIds
      }
      this.selectedMainGoods = []
      this.relVisible = true
      if (this.relForm.rel_item_type !== 'some') return
      // 列表若已带回主品明细，直接回显，不再请求
      if (Array.isArray(row.main_goods) && row.main_goods.length) {
        this.selectedMainGoods = row.main_goods.slice()
        this.relForm.main_goods_ids = this.selectedMainGoods.map(item => item.goods_id)
        return
      }
      if (mainGoodsIds.length) {
        this.loadSelectedMainGoods(mainGoodsIds)
      }
    },
    loadSelectedMainGoods (ids) {
      this.selectedLoading = true
      const idList = ids.map(id => String(id))
      return fetch({
        url: '/goods/items',
        method: 'get',
        params: {
          page: 1,
          pageSize: Math.max(idList.length * 20, 50),
          item_type: 'normal',
          exclude_wrapping: 1,
          is_sku: false,
          goods_id: idList.join(',')
        }
      }).then(res => {
        const data = res.data.data || {}
        const list = data.list || []
        const map = new Map()
        list.forEach(item => {
          const key = String(item.goods_id)
          if (key && key !== 'undefined' && key !== 'null' && !map.has(key)) {
            map.set(key, item)
          }
        })
        // 用 String 对齐，避免接口 number / 列表 string 对不上导致整表为空
        let selected = idList.map(id => map.get(id)).filter(Boolean)
        if (!selected.length && map.size) {
          selected = Array.from(map.values())
        }
        this.selectedMainGoods = selected
        // 回显失败时仍保留原 ids，避免把已关联主品清空
        if (selected.length) {
          this.relForm.main_goods_ids = selected.map(item => item.goods_id)
        }
      }).finally(() => {
        this.selectedLoading = false
      })
    },
    async openGoodsPicker () {
      const { data } = await this.$picker.goodsitem({
        data: this.selectedMainGoods,
        paramsFieldExclude: ['distributor_id'],
        queryParams: {
          is_sku: false,
          exclude_wrapping: 1
        },
        rowKey: 'goods_id',
        multiple: true
      })
      // 按 goods_id 去重，避免同 SPU 多规格重复
      const map = new Map()
      ;(data || []).forEach(item => {
        if (item.goods_id != null && !map.has(item.goods_id)) {
          map.set(item.goods_id, item)
        }
      })
      this.selectedMainGoods = Array.from(map.values())
      this.relForm.main_goods_ids = this.selectedMainGoods.map(item => item.goods_id)
    },
    removeMainGoods (index) {
      this.selectedMainGoods.splice(index, 1)
      this.relForm.main_goods_ids = this.selectedMainGoods.map(item => item.goods_id)
    },
    // 导入是「即落库」，关闭导入弹窗后刷新列表（行内按钮与关联主品弹窗互斥，只需刷新列表）
    afterImport () {
      this.load(this.page)
    },
    saveRel () {
      const payload = Object.assign({}, this.relForm)
      if (payload.rel_item_type === 'some') {
        payload.main_goods_ids = this.selectedMainGoods.map(item => item.goods_id)
      }
      fetch({
        url: '/goods/wrapping/rel',
        method: 'put',
        data: payload
      }).then(() => {
        this.relVisible = false
        this.load(this.page)
      })
    }
  }
}
</script>
